import React from 'react'
import Page from '../../Page'

const Forbidden = () => <Page title='myAMC.ch - Forbidden'><div className='alert alert-danger' role='alert'>This information forbidden for your account type</div></Page>

export default Forbidden
